import React, { useState } from "react";
import { Box, Button, CircularProgress, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccessibleIconButton from "components/base/AccessibleIconButton";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "100vw", sm: "50vw", md: "35vw" },
  bgcolor: "background.paper",
  boxShadow: 0,
  borderRadius: 2,
};

/**
 * Confirmation modal for submission folder actions, styled to match the
 * collection Archive/Unarchive popups.
 */
export default function SubmissionFolderConfirmPopup({
  open,
  onClose,
  onConfirm,
  title,
  confirmLabel,
  children,
}) {
  const [loading, setLoading] = useState(false);

  const confirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={loading ? undefined : onClose}
      slotProps={{ backdrop: { style: { backgroundColor: "rgba(0, 0, 0, 0.2)" } } }}
    >
      <Box sx={modalStyle}>
        <Box sx={{ p: 4 }}>
          <Typography variant="h4" component="div" color="#406da4" fontWeight="600">
            {title}
          </Typography>
          <AccessibleIconButton
            title="Close"
            onClick={onClose}
            disabled={loading}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </AccessibleIconButton>
          <Typography variant="body1" component="div" mt={1}>
            {children}
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: "secondary.main",
            display: "flex",
            justifyContent: "space-between",
            gap: 5,
            px: 5,
            py: 3,
            borderRadius: "0 0 20px 20px",
          }}
        >
          <Button onClick={onClose} variant="outlined" sx={{ width: "45%" }} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={confirm}
            disabled={loading}
            sx={{ width: "45%", display: "flex", gap: 1 }}
          >
            {loading && <CircularProgress size={20} />}
            {confirmLabel}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
